import { useState } from 'react'
import { useRouter } from 'next/router'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, IconButton, Link, Typography } from '@mui/material'
import { string, bool, number } from 'prop-types'
import paths from '../../paths/path'

export default function PaywallTemplate({
  testId = 'paywall-template',
  // articleCount,
  isLoggedIn,
}) {
  const router = useRouter()
  const [showTemplate, setShowTemplate] = useState(true)
  const handleLoginClick = () => {
    const returnUrl = window.location.href
    window.location.href = `${process.env.NEXT_PUBLIC_SALESFORCE_BACKEND_URL}?returnUrl=${returnUrl}`
    sessionStorage.setItem('returnUrl', returnUrl)
  }

  return (
    <>
      {showTemplate && (
        <Box
          data-testid={testId}
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            padding: '1rem 3rem 1.5rem 1rem',
            borderRadius: '0.3125rem 0.3125rem 0 0',
            color: '#fff',
            backgroundColor: '#000',
            zIndex: 900,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              margin: 'auto',
              maxWidth: '55rem',
            }}
          >
            <Typography
              data-testid={`${testId}-title`}
              sx={{
                fontSize: '1.3rem',
                borderRight: '1px solid #777',
                marginRight: '2vw',
                paddingRight: '2vw',
              }}
            >
              {/* You have&nbsp;
              <span style={{ color: '#c3dddb' }}>
                {articleCount} {isLoggedIn ? `free signup` : `free`}
              </span>
              &nbsp;articles left this month. */}
              ISTE+ASCD members can read every <i>Educational Leadership</i>{' '}
              article without limits.
            </Typography>

            <Typography
              data-testid={`${testId}-description`}
              sx={{
                fontSize: '1.3rem',
                textAlign: { md: 'left', sm: 'center' },
                whiteSpace: { md: 'nowrap', sm: '' },
              }}
            >
              {isLoggedIn ? (
                <>
                  <Link
                    sx={{ textDecoration: 'underline', color: '#fff' }}
                    href={paths.subscribe}
                  >
                    Upgrade your account
                  </Link>
                  &nbsp; now for unlimited access.
                </>
              ) : (
                <>
                  <Button
                    sx={{
                      textDecoration: 'underline',
                      color: '#fff',
                      backgroundColor: 'transparent',
                      '&:hover': { backgroundColor: 'transparent' },
                      border: 'none',
                      cursor: 'pointer',
                      display: 'inline',
                      margin: 0,
                      padding: 0,
                      fontSize: '1.3rem',
                    }}
                    onClick={() => {
                      handleLoginClick(true)
                    }}
                  >
                    Sign in
                  </Button>
                  &nbsp;&nbsp;or
                  <Button
                    sx={{
                      textDecoration: 'underline',
                      color: '#fff',
                      backgroundColor: 'transparent',
                      '&:hover': { backgroundColor: 'transparent' },
                      border: 'none',
                      cursor: 'pointer',
                      display: 'inline',
                      margin: 0,
                      padding: 0,
                      fontSize: '1.3rem',
                    }}
                    onClick={() => {
                      router.push('https://iste-ascd.org/membership')
                    }}
                  >
                    join
                  </Button>
                  for unlimited access.
                </>
              )}
            </Typography>
          </Box>

          <IconButton
            aria-label='Close annotations'
            sx={{ position: 'absolute', top: '0.75rem', right: '0.75rem' }}
            onClick={() => {
              setShowTemplate(false)
            }}
            size='large'
          >
            <CloseIcon sx={{ color: '#aaa', fontSize: '2rem' }} />
          </IconButton>
        </Box>
      )}
    </>
  )
}

PaywallTemplate.propTypes = {
  testId: string,
  articleCount: number,
  isLoggedIn: bool,
}
